module.exports = __webpack_public_path__ + "img/retention_flow_retainerdesk.9ed2ee9b.png";